/**
 * Build client routes for machine simulator UIs.
 * @param {string} [routePrefix] - e.g. '' or '/chentronix'
 * @param {string} machineName
 * @returns {string} e.g. /machine/SPM-3000-1 or /chentronix/machine/SPM-3000-1
 */
export function machineDetailPath(routePrefix = '', machineName) {
  const p = (routePrefix || '').replace(/\/$/, '');
  return `${p}/machine/${encodeURIComponent(machineName)}`;
}

/**
 * List/dashboard path for the simulator context.
 * @param {string} [routePrefix]
 * @returns {string}
 */
export function machineListPath(routePrefix = '') {
  const p = (routePrefix || '').replace(/\/$/, '');
  return p === '' ? '/' : p;
}

/**
 * Operator UI with dynamic HMI (?hmi=1&type=CODE). Honors VITE_OPERATOR_MACHINE_BASE when set.
 * @param {string} machineName
 * @param {string} typeCode - MachineTypeDefinition.code e.g. CNC_LATHE
 */
export function dynamicHmiOperatorUrl(machineName, typeCode) {
  const qs = new URLSearchParams({ hmi: '1', type: typeCode });
  const base = import.meta.env.VITE_OPERATOR_MACHINE_BASE;
  if (base) {
    const b = base.replace(/\/$/, '');
    return `${b}/${encodeURIComponent(machineName)}?${qs}`;
  }
  return `${machineDetailPath('', machineName)}?${qs}`;
}
